export default "__VITE_PUBLIC_ASSET__5a767db8__"